































import { ButtonType } from '@getaccept/lib-ui';
import { initialHelper } from '@getaccept/lib-shared/src/helpers';
import { computed, defineComponent, onMounted, ref, watch } from '@vue/composition-api';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { SigningHelper } from '../../helpers/signing.helper';

export default defineComponent({
  props: {
    fullName: {
      type: String,
      default: '',
    },
    initials: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const initialsInput = ref('');
    const initialsValidation = ref('');

    const watchInitials = () => {
      initialsValidation.value = '';
    };
    watch(() => props.initials, watchInitials);

    const submit = () => {
      initialsValidation.value = SigningHelper.validateInitials(initialsInput.value);

      if (!initialsValidation.value) {
        emit('submit', initialsInput.value.toUpperCase());
      }
    };

    const cancel = () => {
      emit('cancel');
    };

    onMounted(() => {
      initialsInput.value = props.initials || initialHelper(props.fullName);
    });

    const headerText = computed((): string => {
      if (props.initials) {
        return t('edit-initials').toString();
      }
      return t('add-initials').toString();
    });

    return {
      ButtonType,
      initialsInput,
      initialsValidation,
      watchInitials,
      submit,
      cancel,
      headerText,
    };
  },
});
